import { FC, ReactNode } from "react";

interface SectionHeaderProps {
    title?: string;
    actionButton: ReactNode;
}

export const SectionHeader: FC<SectionHeaderProps> = ({
    title,
    actionButton,
}) => {
    return (
        <div className="flex flex-row justify-between items-start pb-3">
            {title && <div className="text-sky-950 sm:pt-3 text-2xl sm:text-3xl" style={{ fontFamily: 'Bebas Neue' }}>{title}</div>}
            {actionButton}
        </div>
    )
}
